import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { MembershipPlanModel } from 'src/app/admin-panel/models/business/membership-plan.model';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { MembershipPlanService } from 'src/app/admin-panel/services/business/membership-plan.service';

@Component({
  selector: 'app-add-or-edit-membership-plans',
  templateUrl: './add-or-edit-membership-plans.component.html',
  styleUrls: ['./add-or-edit-membership-plans.component.scss']
})
export class AddOrEditMembershipPlansComponent implements OnInit {

  //#region Fields
  public membershipPlanId: string;
  public membershipPlanModel: MembershipPlanModel;
  public enableEdit: boolean = false;
  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  public countryItem: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public errorModel: { [k: string]: any } = {};
  public requiredFieldErrorMessage = "BUSINESS.REQUIRED_FIELD";
  public projectId: number;
  //#endregion
  //#region Constructor
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    public membershipPlanService: MembershipPlanService,
    public messageService: MessageService
  ) {
    this.membershipPlanModel = new MembershipPlanModel();
    if (this.config.data != undefined && this.config.data.id) {
      this.membershipPlanId = this.config.data.id;
    }
    if (this.config.data != undefined && this.config.data.projectId) {
      this.projectId = this.config.data.projectId;
    }
  }

  ngOnInit(): void {
    if (this.membershipPlanId) {
      this.getproductbyid(this.membershipPlanId)
    }
    this.getallcountrynames()
  }

  //#endregion
  //#region Public Methods
  getproductbyid(id: string) {
    this.spinner = true;
    this.membershipPlanService.getproductbyid(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.enableEdit = true
          this.membershipPlanModel = response;
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
          }
        }
      });
  }

  getallcountrynames() {
    this.membershipPlanService.getallcountrynames()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.countryItem = response;
        },
        error: errorResponse => {
          if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
          }
        }
      });
  }
  saveMembershipPlan(model: MembershipPlanModel) {
    this.errorModel = {}
    if (model && model.name == "") {
      this.errorModel['name'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.defaultMonthlyPrice) {
      this.errorModel['defaultMonthlyPrice'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.defaultYearlyPrice) {
      this.errorModel['defaultYearlyPrice'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.minNumberOfVenues) {
      this.errorModel['minNumberOfVenues'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.maxNumberOfVenues) {
      this.errorModel['maxNumberOfVenues'] = this.requiredFieldErrorMessage;
    }
    if (model && model.countryIds.length == 0) {
      this.errorModel['countryIds'] = this.requiredFieldErrorMessage;
    }
    if (!(Object.keys(this.errorModel).length > 0)) {
      model.projectId = this.projectId;
      this.spinner = true;
      this.membershipPlanService.addproduct(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            if (errorResponse.error) {
              this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
            }
          }
        });
    }
  }
  editMembershipPlan(model: MembershipPlanModel) {
    this.errorModel = {}
    model.productId = this.membershipPlanId;
    if (model && model.name == "") {
      this.errorModel['name'] =this.requiredFieldErrorMessage;
    }
    if (model && !model.defaultMonthlyPrice) {
      this.errorModel['defaultMonthlyPrice'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.defaultYearlyPrice) {
      this.errorModel['defaultYearlyPrice'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.minNumberOfVenues) {
      this.errorModel['minNumberOfVenues'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.maxNumberOfVenues) {
      this.errorModel['maxNumberOfVenues'] = this.requiredFieldErrorMessage;
    }
    if (model && model.countryIds.length == 0) {
      this.errorModel['countryIds'] = this.requiredFieldErrorMessage;
    }
    if (!this.errorModel['name'] && !this.errorModel['defaultMonthlyPrice'] && !this.errorModel['defaultYearlyPrice'] && !this.errorModel['minNumberOfVenues'] && !this.errorModel['maxNumberOfVenues'] && !this.errorModel['countryIds']) {
      this.spinner = true;
      this.membershipPlanService.updateproduct(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            if (errorResponse.error) {
              this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
            }
          }
        });
    }
  }
  cancel() {
    this.ref.close(false)
  }
  //#endregion
  //#Private Methods
  //#endregion
}
